/**
 *
 * Asynchronously loads the component for MemberDetail
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
